import React from 'react';

export const SendIcon = ({
  width = '15',
  height = '15',
  color = '#344054',
  'aria-hidden': ariaHidden = true,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 15 15"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={ariaHidden}
    {...rest}
  >
    <path
      d="M14.0833 0.75L6.75 8.08333M14.0833 0.75L9.41667 14.0833L6.75 8.08333M14.0833 0.75L0.75 5.41667L6.75 8.08333"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
